import axiosInstance from "../axiosClient";
import { Admin, AdminList, DeleteApi, ExcelFile, subAdmin, UpdateAdmin, updateAdminPassword, updateAdminStatus, updatePassword } from "../config";



export const getAdmin = async (name,limit,start_key) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.get(`${AdminList}${queryString}`);
};
  
export const update_Admin=  async(data) => {
  return await axiosInstance.patch(UpdateAdmin,data);
};


export const createAdmin = async (data) => {
  return await axiosInstance.post(Admin,data);
};

export const getSubAdmin=async(name,limit,start_key)=>{
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.get(`${subAdmin}${queryString}`)


}

export const handleUpdateAdminStatus= async(id,activate)=>{
   let queryParams = [];
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  if (activate || !activate) queryParams.push(`activate=${encodeURIComponent(activate)}`);
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.patch(`${updateAdminStatus}${queryString}`)

}



export const handleDeleteApi= async(id,type)=>{
   let queryParams = [];
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`);
  if (type) queryParams.push(`type=${encodeURIComponent(type)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.delete(`${DeleteApi}${queryString}`)

}

export const handleUpdatePassword= async(data)=>{
  return await axiosInstance.patch(updatePassword , data);
}

export const handleAdminPassword= async(id)=>{
  let queryParams=[]
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`)
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.patch(`${updateAdminPassword}${queryString}`)
}


export const ExcelFileUpload = async (data) =>{
   return await axiosInstance.post(ExcelFile,data,
    {
      headers: {
        'Content-Type': "multipart/form-data"
    }
    }
   );
}